import { browserHistory } from 'react-router'
import axios from 'axios'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export function requestPage( slug, requentOnly ) {
	return {
		type: 'REQUEST_PAGE_DATA',
		payload: {
			slug: slug,
			requentOnly: requentOnly
		}
	}
}

export function receivePage( slug, json ) {
	return {
		type: 'RECEIVE_PAGE_DATA',
		payload: {
			slug: slug,
			data: json
		}
	}
}

export function receivePageError( json ) {
	return {
		type: 'RECEIVE_PAGE_ERROR',
		payload: json
	}
}

export function setCurrentPage( slug ) {
	return {
		type: 'SET_CURRENT_PAGE',
		payload: slug
	}
}

export function getPageData( slug, type = 'page', archivePageNumber = false, requentOnly = false ) {
	return function( dispatch, getState ) {
		const { byId, loadingById } = getState().page
		const { locale } = getState().site

		// Normalise slug, removing /
		slug = slug.replace( /\//g, '' )

		// Don't load the same thing simultaneously:
		if ( loadingById[ 'id_' + slug ] ) {
			return
		}

		// Short circuit for existing data:
		if ( byId[ 'id_' + slug ] ) {
			// Ensure the locale is the same:
			if ( ! requentOnly ) {
				dispatch( receivePage( slug, byId[ 'id_' + slug ] ) )
				dispatch( setCurrentPage( slug ) )
			}

			return
		}

		dispatch( requestPage( slug, requentOnly ) )

		if ( ! requentOnly ) {
			dispatch( showLoading() )
		}

		return axios({
				url: siteData.api_base_url + type + '/?slug=' + slug + '&page_number=' + archivePageNumber,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receivePage( slug, response.data ) )

				if ( ! requentOnly ) {
					dispatch( hideLoading() )
					dispatch( setCurrentPage( slug ) )
				}
			})
			.catch( function( error ) {

			})
	}
}

export function receiveOffersData( data ) {
	return {
		type: 'RECEIVE_OFFERS_DATA',
		payload: data
	}
}

export function getOffersData() {
	return function( dispatch ) {
		return axios({
				url: siteData.api_base_url + 'offers',
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receiveOffersData( response.data ) )
			})
			.catch( function( error ) {
				console.log( error, 'error' );
			})
	}
}



// WEBPACK FOOTER //
// ./redux/actions/page.jsx